export const SUPPORTED_ENGINE_VERSION = '1.13.1'
// Used by the Commons API clients
window.__env.SUPPORTED_ENGINE_VERSION = SUPPORTED_ENGINE_VERSION
export default window.__env
